import { useState } from 'react';
import { supabase } from '../lib/supabase';

const BUCKET = 'exames-resultados';

export function useExameResultado() {
  const [uploading, setUploading] = useState(false);

  async function uploadResultado(alunaId, exameId, file) {
    setUploading(true);
    try {
      const ext = file.name.split('.').pop();
      const path = `${alunaId}/${exameId}/${Date.now()}.${ext}`;
      const { error } = await supabase.storage
        .from(BUCKET)
        .upload(path, file, { contentType: file.type });
      if (error) throw error;
      return { path, nomeArquivo: file.name, tipo: file.type, enviadoEm: new Date().toISOString() };
    } finally {
      setUploading(false);
    }
  }

  async function abrirResultado(path) {
    const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, 60);
    if (error) throw error;
    window.open(data.signedUrl, '_blank', 'noopener');
  }

  async function removerArquivo(path) {
    await supabase.storage.from(BUCKET).remove([path]);
  }

  return { uploadResultado, abrirResultado, removerArquivo, uploading };
}
